export default new class MessagesUtil {
    LstOfListeners = [];

    constructor() {
        var classContext = this;

        window.addEventListener('MessagingEvent', function (event) {
            if (event && event.detail) {
                for (var i = 0; i < classContext.LstOfListeners.length; i++) {
                    classContext.LstOfListeners[i](event.detail);
                }
            }
        });
    }

    dispatchEvent(eventData) {
        window.dispatchEvent(new CustomEvent('MessagingEvent', { 'detail': eventData }));
    };

    listenToEvents(func) {
        if (func) {
            this.LstOfListeners.push(func)
        }
    }
}